import { configureStore } from '@reduxjs/toolkit'
import bottomBarMenuReducer from '../redux/slices/BottomBarMenuSlice'

export const store = configureStore({
    reducer: {
        bottomBarMenuIndex: bottomBarMenuReducer //Bottom bar menu on main screen in mobile devices
    },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch